/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { applicationState } from "./application.state";

const application = createSlice({
    name: "application",

    initialState: applicationState,

    reducers: {
        setApplications (state, action) {
            const apps = action.payload;
            state.all = apps;
        },
        setApplicationItem (state, action) {
            const app = action.payload;
            const guid = app.guid;
            state.byGUID[guid] = app;
            state.current = app;
        },
    },
});

export const applicationReducer = application.reducer;

export const {
    setApplicationItem,
    setApplications
} = application.actions;
